import { CoreIcon } from '../core-icon';
import errorCircleFillSVG from '../../assets/icons/error-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const ErrorCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={errorCircleFillSVG} {...props} />;
};
